// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBZqh9kyE7CuZkLfYisw6GS-u2JEiQAJiU",
    authDomain: "casa-de-los-cristales.firebaseapp.com",
    projectId: "casa-de-los-cristales",
    storageBucket: "casa-de-los-cristales.firebasestorage.app",
    messagingSenderId: "242310170566",
    appId: "1:242310170566:web:c30016b058281d6a8794c7",
    measurementId: "G-SE28QMG86W"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)